import React, { useState, useEffect } from 'react'
import NEW_COLOR_PICKER from './_NewColorPicker'
import { SketchPickerProps } from 'react-color'
import { Button, ColorSquare, Popover } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import { Classes } from '@blueprintjs/core'

export default function ColorSelect({
  value,
  buttonProps,
  onChange,
  disabled,
}: {
  value?: string
  onChange: (color: string) => Promise<any>
  buttonProps?: IUIButtonProps
  disabled?: boolean
}) {
  const [color, setColor] = useState<string | undefined>(value)
  useEffect(() => setColor(`#${value}`), [value])

  return (
    <Popover
      minimal
      disabled={disabled}
      content={
        <div>
          <ColorPicker
            color={color}
            disableAlpha
            onChange={({ hex }) => {
              setColor(hex)
            }}
          />
          <div className="px-3 pb-3 bg-white rounded">
            <Button
              fill
              disabled={color?.slice(1) === value}
              text="Assign Color"
              className={Classes.POPOVER_DISMISS}
              onClick={() => {
                if (color) {
                  onChange(color.slice(1))
                  setColor(undefined)
                }
              }}
            />
          </div>
        </div>
      }
    >
      <Button
        rightIconName="chevron-down"
        text={
          buttonProps?.text ?? <ColorSquare skeleton={!value} style={{ background: `#${value}` }} />
        }
        {...buttonProps}
        {...(disabled ? { disabled: true } : {})}
      />
    </Popover>
  )
}

export function ColorPicker(props: SketchPickerProps) {
  return <NEW_COLOR_PICKER {...props} />
}
